import React from "react";
import TextButton from "@components/ui/buttons/TextButton";
import ActionButton from "@components/ui/buttons/ActionButton";
import { useTranslation } from "react-i18next";
import { t_help } from "@i18n/usualTexts/t_help";

interface NavigationButtonsProps {
  back?: Function;
  isLoading: boolean;
  isMobileNav: boolean;
  onMobileSubmit?: () => void;
}

const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  back,
  isLoading,
  isMobileNav,
  onMobileSubmit,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-3">
      <div className="flex-1">
        <TextButton variant="secondary" className="w-full h-11" onClick={() => back?.()}>
          {t(t_help.backButton)}
        </TextButton>
      </div>
      <div className="flex-1">
        <ActionButton
          submit
          isLoading={isLoading}
          onClick={isMobileNav ? onMobileSubmit : undefined}
          className={isMobileNav ? "h-11 w-full" : "w-full"}
        />
      </div>
    </div>
  );
};

export default NavigationButtons;
